import { Injectable } from '@angular/core';
import { FieldTypes, InputConfig } from '@tmhcc-ng-lib/framwork/form-inputs';
import { Validators } from '@angular/forms';

@Injectable()
export class AgencyConfigInfo {
  constructor() {}

  quoteInformationConfig = {
    quoteFieldConfig: [
      // {
      //   fieldInfo: {
      //     fieldName: 'upn1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      {
        fieldInfo: {
          fieldName: 'aor1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 80,
          fieldLength: 80,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      // {
      //   fieldInfo: {
      //     fieldName: 'kraft_lake_entity_type1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'agency_status1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      {
        fieldInfo: {
          fieldName: 'first_name1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      {
        fieldInfo: {
          fieldName: 'last_name1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      {
        fieldInfo: {
          fieldName: 'agency_name1',
          //fieldId: 'agency_name1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          //validation: [Validators.required],
          isDisabled: true
        }
      },
      // {
      //   fieldInfo: {
      //     fieldName: 'tax_id1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'tax_id_type1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'sub_company1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'kraft_lake_agency_type1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'commission_option1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'payment_plan1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'commission_plan1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'commission_amount1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'kraft_lake_eo_carrier1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'eo_limits1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'eo_policy_number1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'eo_expiration_date1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'address_type1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      {
        fieldInfo: {
          fieldName: 'office_address1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      {
        fieldInfo: {
          fieldName: 'city1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      {
        fieldInfo: {
          fieldName: 'state1',
          label: '',
          fieldType: FieldTypes.LookupList,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          selectConfig: {
            options: [],
            optionConfig: {
              displayKey: 'value',
              search: false,
              limitTo: 3
            },
            multiple: false
          }
        }
      },
      {
        fieldInfo: {
          fieldName: 'zip1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      // {
      //   fieldInfo: {
      //     fieldName: 'office_country1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'phone_type1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      {
        fieldInfo: {
          fieldName: 'phone1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      },
      // {
      //   fieldInfo: {
      //     fieldName: 'email_type1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      {
        fieldInfo: {
          fieldName: 'email1',
          label: '',
          fieldType: FieldTypes.Text,
          maxChar: 40,
          fieldLength: 40,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      }
      // {
      //   fieldInfo: {
      //     fieldName: 'licensee_name1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     isDisabled: false
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'ParentLicenseType1',
      //     label: '',
      //     fieldType: FieldTypes.LookupList,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     selectConfig: {
      //       options: [],
      //       optionConfig: {
      //         displayKey: 'value',
      //         search: false,
      //         limitTo: 3
      //       },
      //       multiple: false
      //     }
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'LicenseNumber1',
      //     label: '',
      //     fieldType: FieldTypes.LookupList,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //     ]
      //   },
      //   config: {
      //     validation: [Validators.required],
      //     selectConfig: {
      //       options: [],
      //       optionConfig: {
      //         displayKey: 'value',
      //         search: false,
      //         limitTo: 3
      //       },
      //       multiple: false
      //     }
      //   }
      // },
      // {
      //   fieldInfo: {
      //     fieldName: 'license_expiration_date1',
      //     label: '',
      //     fieldType: FieldTypes.Text,
      //     maxChar: 40,
      //     fieldLength: 40,
      //     showLabel: true,
      //     required: true,
      //     validations: [
      //       {
      //         key: 'required',
      //         value: ''
      //       }
      //   ]
      // },
      // config: {
      //   validation: [Validators.required],
      //   isDisabled: false
      // }
      // }
    ]
  };
  phoneRequestForm = {
    phoneRequestFieldConfig: [
      {
        fieldInfo: {
          fieldName: 'phone1',
          label: '',
          maxChar: 10,
          minlength: 10,
          fieldLength: 10,
          fieldType: FieldTypes.Numeric,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            },
            {
              key: 'minlength',
              value: 'Please enter atleast 10 digits'
            }
          ]
        },

        config: {
          validation: [Validators.required, Validators.minLength(10)],

          isDisabled: false,

          numericConfig: {
            type: 'phone'
          }
        }
      }
    ]
  };
  emailRequestForm = {
    emailRequestFieldConfig: [
      {
        fieldInfo: {
          fieldName: 'email1',
          feildEmailInfo: 'email1',
          label: '',
          fieldType: FieldTypes.Email,
          maxChar: 80,
          fieldLength: 80,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: ''
            },
            {
              key: 'pattern',
              value: 'Please enter a valid email address'
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false
        }
      }
    ]
  };
  agencyRequestProducts = {
    agencyRequestProductsFieldConfig: [
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      },
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v1',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      },
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v2',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      },
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v3',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      },
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v4',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      },
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa0v5',
          label: '',
          fieldType: FieldTypes.Checkbox,
          showLabel: true
        },
        config: {}
      }
    ]
  };
  companyRequest = {
    companyRequestFieldConfig: [
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa98',
          label: 'companyRequest',
          fieldType: FieldTypes.Text,
          showLabel: false
        },
        config: {}
      }
    ]
  };
  premiumProducts = {
    premiumFieldConfig: [
      {
        fieldInfo: {
          fieldName: '00N6g00000TXa9h',
          label: 'radio',
          fieldType: FieldTypes.Radio,
          showLabel: true,
          required: true,
          validations: [
            {
              key: 'required',
              value: 'Company is required'
            }
          ]
        },
        config: {
          validation: [Validators.required],
          isDisabled: false,
          radioCofig: {
            radioGroup: [
              {
                label: '$50,000-$100,000',
                value: '$50,000-$100,000',
                style: 'pl-0 float-left'
              },
              {
                label: '$100,001-$250,000',
                value: '$100,001-$250,000',
                style: 'pl-0 float-left'
              },
              {
                label: '$250,001-$500,000',
                value: '$250,001-$500,000',
                style: 'pl-0 float-left'
              },

              {
                label: '$500,001-$1,000,000',
                value: '$500,001-$1,000,000',
                style: 'pl-0 float-left'
              },

              {
                label: 'Over $1,000,000',
                value: 'Over $1,000,000',
                style: 'pl-0 float-left'
              }
            ]
          }
        }
      }
    ]
  };
  // cn = {
  //   first_name: '',
  //   last_name: '',
  //   company: '',
  //   city: '',
  //   RequestState: '',
  //   phone: '',
  //   email: '',
  //   oid: '',
  //   retURL: '',
  //   lead_source: '',
  //   debug: '',
  //   debugEmail: ''
  // };
  cn = {
    //upn: '',
    aor: '',
    //kraft_lake_entity_type: '',
    //agency_status: '',
    first_name: '',
    last_name: '',
    agency_name: '',
    //tax_id: '',
    //tax_id_type: '',
    //sub_company: '',
    //kraft_lake_agency_type: '',
    //commission_option: '',
    //payment_plan: '',
    //commission_plan: '',
    //commission_amount: '',
    //kraft_lake_eo_carrier: '',
    //eo_limits: '',
    //eo_policy_number: '',
    //eo_expiration_date: '',
    //address_type: '',
    office_address: '',
    city: '',
    state: '',
    zip: '',
    // office_country: '',
    //phone_type: '',
    phone: '',
    //email_type: '',
    email: '',
    //licensee_name: '',
    ParentLicenseType: '',
    LicenseNumber: '',
    license_expiration_date: '',
    oid: '',
    retURL: '',
    lead_source: '',
    debug: '',
    debugEmail: ''
  };
}
